// extracted by mini-css-extract-plugin
export default {"blueWave":"future_tEYkS7tlkaQh","greenWave":"future_LpMeEFi70c09","bgGreen":"future_MvYsG2c37I4K","bgYellow":"future_TyN9LChZXHEW","container":"future_jzqtpbxDicQg"};